import { useState } from 'react';
import { getDetailLocationFromLatLong, isEmptyData } from '../../../../utils/helper';
import { GpsIcon } from '../../../../utils/svg';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../../../store/reducers/user';

const CurrentLocation = (props) => {
	const { onClose } = props;

	const dispatch = useDispatch();
	const [location, setLocation] = useState(null);
	const { coords } = useSelector((store) => store?.gps);

	const handleCurrentLocation = async () => {
		if (isEmptyData(coords?.latitude) || isEmptyData(coords?.longitude)) return;
		const formating = await getDetailLocationFromLatLong(coords?.latitude, coords?.longitude);
		if (!isEmptyData(formating)) {
			setLocation({
				address: formating?.address,
				city: formating?.city,
				country: formating?.country,
				detail: null,
				district: formating?.district,
				latitude: formating?.lat,
				longitude: formating?.lng,
				name: formating?.name,
				postalCode: formating?.postalCode,
				state: formating?.state,
				village: formating?.village,
			});
		}
	};

	useEffect(() => {
		handleCurrentLocation();
	}, [coords]);

	const handleClick = (data = null) => {
		if (isEmptyData(data?.latitude) || isEmptyData(data?.longitude)) return;
		dispatch(
			setUser({
				addressName: data?.name ?? null,
				address: data?.address,
				latitude: Number(data?.latitude),
				longitude: Number(data?.longitude),
				country: data?.country,
				state: data?.state,
				city: data?.city,
				village: data?.village,
				district: data?.district,
				postalCode: data?.postalCode ?? '',
				detail: data?.detail ?? null,
			}),
		);
		onClose();
	};

	return (
		<div className='flex gap-2 5 items-center pb-4' onClick={() => handleClick(location)}>
			<GpsIcon className={'stroke-gray-500 w-5 min-w-5 h-auto'} />
			<div className='grow space-y-0.5'>
				<p className='text-[var(--dark-gray)] text-sm font-semibold'>Lokasi saat ini</p>
				<p className='text-[var(--dark-gray)] text-xxs'>{location?.address}</p>
			</div>
		</div>
	);
};

export default CurrentLocation;
